export default "__VITE_ASSET__CDmlJtN$__"